
const config = {
  key: 'AIzaSyC1c6Fr0HmWLhA5ZVA64vu8HsfRl5UCOZQ',
  //key: 'your-google-api-key',
  libraries: 'places'
};

export default config



// WEBPACK FOOTER //
// ./src/google-maps-config.js